import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ListFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Input, Stack } from '@lyearn/ui';
import ReactionSelector from '@/modules/corporate/modules/community/views/CommunityEditor/components/CommunityEditorSidebar/components/CommunityChannelEditor/components/ReactionSelector';

import { inputStyles } from './styles';

interface ListNameAndEmojiProps {
  name: string;
  icon: string;
  onChangeName: (value: string) => void;
  onChangeIcon: (reaction: string) => void;
  error: string;
}

const CHARACTER_LIMIT = 64;

function SectionNameAndEmoji(props: ListNameAndEmojiProps) {
  const { t } = useTranslation();
  const { name, icon, onChangeName, onChangeIcon, error } = props;

  const _onChangeName = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      onChangeName(event.currentTarget.value);
    },
    [onChangeName],
  );

  const _onChangeIcon = useCallback(
    (emoji: any) => {
      emoji && onChangeIcon(emoji);
    },
    [onChangeIcon],
  );

  return (
    <Stack className="w-full">
      <Input
        characterLimit={CHARACTER_LIMIT}
        className={cn('w-full', inputStyles)}
        error={!!error}
        inputProps={{
          className: 'ms-12',
        }}
        placeholder={t('Task:Section.NamePlaceholder')}
        size="large"
        startAdornment={
          <ReactionSelector
            EmojiDefaultIcon={ListFill}
            className={{ button: 'px-12' }}
            icon={icon}
            onSelect={_onChangeIcon}
          />
        }
        value={name}
        onChange={_onChangeName}
      />
    </Stack>
  );
}

export default SectionNameAndEmoji;
